import React from 'react';

import BasicText from '@ui/atoms/BasicText';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

export const uneditableFieldView = (title: string, disclaimer: string, data = 'Not Provided') => {
	return (
		<>
			<BasicText variant="field">{title}</BasicText>
			<BasicText>{data}</BasicText>
			<WYSIWYGContent textVariant="fineprint" dangerouslySetInnerHTML={{ __html: disclaimer }} />
		</>
	);
};
